export default "__VITE_ASSET__2M8ibhOQ__"